// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.description-plugin {
    font-family: Helvetica, Arial, sans-serif;
    padding: 1px;
    color: #f0f0f0;
    min-width: 300px
}

.description-plugin .row {
    display: flex;
    min-width: 100px;
    padding-top: 1px;
    padding-bottom: 1px;
    border-bottom: 1px #d3a84c dotted;
}

.description-plugin .row .key {
    max-width: 20%;
    margin-right: 15px;
}

.description-plugin .row .value {
    margin-left: auto;
    max-width: 80%;
    color: lightgray
}

.description-plugin a {
    color: lightslategray
}
`, "",{"version":3,"sources":["webpack://./src/css/DescriptionPlugin.css"],"names":[],"mappings":";AACA;IACI,yCAAyC;IACzC,YAAY;IACZ,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ","sourcesContent":["\n.description-plugin {\n    font-family: Helvetica, Arial, sans-serif;\n    padding: 1px;\n    color: #f0f0f0;\n    min-width: 300px\n}\n\n.description-plugin .row {\n    display: flex;\n    min-width: 100px;\n    padding-top: 1px;\n    padding-bottom: 1px;\n    border-bottom: 1px #d3a84c dotted;\n}\n\n.description-plugin .row .key {\n    max-width: 20%;\n    margin-right: 15px;\n}\n\n.description-plugin .row .value {\n    margin-left: auto;\n    max-width: 80%;\n    color: lightgray\n}\n\n.description-plugin a {\n    color: lightslategray\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
